/**
 * Per-tab restaurant selection.
 *
 * `rest.selectedRest` is persisted by redux-persist into one localforage record shared by every tab,
 * so whichever tab wrote last decided what every other tab got on reload. sessionStorage is per-tab,
 * so a reload keeps this tab's own choice; a brand-new tab still falls back to the persisted value.
 */
const KEY = 'cloudix:selectedRestaurant'

export const getTabRestaurant = () => {
  try {
    return window.sessionStorage.getItem(KEY) || ''
  } catch (e) {
    return ''
  }
}

export const setTabRestaurant = (uuid) => {
  try {
    if (uuid) window.sessionStorage.setItem(KEY, uuid)
    else window.sessionStorage.removeItem(KEY)
  } catch (e) {
    // storage blocked (private mode, sandboxed iframe): fall back to the shared persisted value
  }
}
